import { API_URL, FetchApi } from './service';
import type {
  CompleteV2ScoringResult,
  SimulationResult,
  ScoringHistory,
  EnrichmentConsents,
} from '@/types/scoring-v2';

const URI = `${API_URL}/core/scoring-v2/`;

interface ApiResponse<T> {
  success: boolean;
  data: T;
}

interface ScoreApplicationRequest {
  application_id: string;
  use_enrichment?: boolean;
  consents?: EnrichmentConsents;
  force_refresh?: boolean;
}

interface SimulateScenarioRequest {
  application_id: string;
  scenario: any;
}

export const ScoringV2Service = {
  /**
   * Calculer le score d'une application
   */
  scoreApplication: async (request: ScoreApplicationRequest): Promise<CompleteV2ScoringResult> => {
    const response = await FetchApi.post<ApiResponse<CompleteV2ScoringResult>>(
      `${URI}score/`,
      request
    );
    return response.data;
  },

  /**
   * Simuler un scénario de scoring
   */
  simulateScenario: async (request: SimulateScenarioRequest): Promise<SimulationResult> => {
    const response = await FetchApi.post<ApiResponse<SimulationResult>>(
      `${URI}simulate/`,
      request
    );
    return response.data;
  },

  /**
   * Récupérer l'historique des scores
   */
  getHistory: async (applicationId: string): Promise<ScoringHistory> => {
    const response = await FetchApi.get<ApiResponse<ScoringHistory>>(
      `${URI}history/?application_id=${applicationId}`
    );
    return response.data;
  },
};

export default ScoringV2Service;
